module.exports = __webpack_public_path__ + "img/TechArchMarksmanship_ua.35bea44b.webp";